/** The bearer token lives in localStorage so a reload keeps the session. */
const KEY = 'personal-os.web.token';

function storage(): Storage | null {
  try {
    const candidate = (globalThis as { localStorage?: Storage }).localStorage;
    return candidate && typeof candidate.getItem === 'function' ? candidate : null;
  } catch {
    return null;
  }
}

export const tokenStorage = {
  get(): string | null {
    return storage()?.getItem(KEY) ?? null;
  },
  set(token: string): void {
    storage()?.setItem(KEY, token);
  },
  clear(): void {
    storage()?.removeItem(KEY);
  },
};
